<template>
  <span class="inline-flex items-center gap-1 whitespace-nowrap rounded px-2 py-0.5 text-xs font-semibold tabular-nums" :class="[toneClass, { 'line-through opacity-70': struck }]">
    <span class="font-medium opacity-80">{{ code }}</span>{{ quantity }}
  </span>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  const props = withDefaults(defineProps<{ code: string; quantity: number; tone?: 'neutral' | 'old' | 'new'; struck?: boolean }>(), {
    tone: 'neutral',
    struck: false,
  });

  const TONE_CLASS: Record<'neutral' | 'old' | 'new', string> = {
    neutral: 'bg-gray-100 text-gray-700',
    old: 'bg-red-50 text-red-700',
    new: 'bg-green-50 text-green-700',
  };

  const toneClass = computed(() => TONE_CLASS[props.tone]);
</script>
